const typeFun = (flag)=>{
  if(flag){
    return 'dark';
  }else{
    return 'light';
  }
}
const domThemeSchemeToggle = (state, data)=>{
  state.rootDom.setAttribute('theme-color-scheme', data);
}

// name: themeScheme
const state = {
  rootDom: document.querySelector(':root'),
  themeVal: 'light',
};
const getters = {
  getThemeVal: (state)=>{ return state.themeVal; },
};
const mutations = {
  themeToggle(state, flag){
    const data = typeFun(flag);
    domThemeSchemeToggle(state, data);
    state.themeVal = data;
  }
};
const actions = {
  themeToggle(store, data){
    store.commit('themeToggle', data);
  }
};
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
